import { render, staticRenderFns } from "./AppCharacter.vue?vue&type=template&id=021022e6&scoped=true&"
import script from "./AppCharacter.vue?vue&type=script&lang=js&"
export * from "./AppCharacter.vue?vue&type=script&lang=js&"
import style0 from "./AppCharacter.vue?vue&type=style&index=0&id=021022e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021022e6",
  null
  
)

export default component.exports